import styled from "styled-components";

import MainNavButton from "../MainNav/Button";

export const RentDropdownButton = styled(MainNavButton)``;
